import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { virtualKoteachModel } from "../../../entities/VirtualKoteach";
import { animations_15_fps } from "../../../assets/animations/15_FPS";
import { animations_30_fps } from "../../../assets/animations/30_FPS";
import "./AnimationFrame.scss";

const AnimationFrame: React.FC = () => {
  const [currentFrame, setCurrentFrame] = useState(0);

  const display_animation_name = useSelector(
    virtualKoteachModel.selectDisplayAnimationState
  );
  const display_animation_fps = useSelector(
    virtualKoteachModel.selectDisplayAnimationFPS
  );
  const animations =
    display_animation_fps === 15 ? animations_15_fps : animations_30_fps;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFrame(
        (prevFrame) =>
          (prevFrame + 1) % animations[display_animation_name].length
      );
    }, 1000 / display_animation_fps);

    return () => clearInterval(interval);
  }, [display_animation_fps, display_animation_name, animations]);

  return (
    <div>
      <img
        className={`animation_frame`}
        src={animations[display_animation_name][currentFrame]}
        alt="Display state animation"
      />
      <div>{`Display state: ${display_animation_name}`}</div>
      <div>{`Animation FPS: ${display_animation_fps}`}</div>
    </div>
  );
};

export default AnimationFrame;
